import { makeStyles } from '@mui/styles';

const avatarStyles = makeStyles((theme) => ({
    root: {
        marginRight: '8px'
    },
    xs: {
        width: theme.spacing(6),
        height: theme.spacing(6),
        "& .MuiAvatar-root": {
            width: theme.spacing(6),
            height: theme.spacing(6),
        }
    },
    small: {
        width: theme.spacing(7),
        height: theme.spacing(7),
        "& .MuiAvatar-root": {
            width: theme.spacing(7),
            height: theme.spacing(7),
        }
    },
    medium: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        "& .MuiAvatar-root": {
            width: theme.spacing(10),
            height: theme.spacing(10),
        }
    },
    large: {
        width: theme.spacing(14),
        height: theme.spacing(14),
        "& .MuiAvatar-root": {
            width: theme.spacing(14),
            height: theme.spacing(14),
        }
    },
    xlarge: {
        width: theme.spacing(21),
        height: theme.spacing(21),
        "& .MuiAvatar-root": {
            width: theme.spacing(21),
            height: theme.spacing(21),
        }
    }
}));

export const avatarGroupStyles = makeStyles((theme) => ({
    root: {
        marginRight: '8px'
    },
    xs: {
        "& .MuiAvatar-root": {
            width: theme.spacing(6),
            height: theme.spacing(6),
        }
    },
    small: {
        "& .MuiAvatar-root": {
            width: theme.spacing(7),
            height: theme.spacing(7),
        }
    },
    medium: {
        "& .MuiAvatar-root": {
            width: theme.spacing(10),
            height: theme.spacing(10),
        }
    },
    large: {
        "& .MuiAvatar-root": {
            width: theme.spacing(14),
            height: theme.spacing(14),
        }
    },
    xlarge: {
        "& .MuiAvatar-root": {
            width: theme.spacing(21),
            height: theme.spacing(21),
        }
    }
}));

export default avatarStyles;